import Marionette from "../../shared/marionette-mustache";
import { ResultModel } from "../../search/models/result";
import { backboneViewProperties } from "../../decorators/backbone-properties";
import { AppEvents } from "../../app-events";
import { Container } from "aurelia-dependency-injection";
import { ContainerHelper } from "../../shared/helpers/container-helper";

require("../styles/results.less");
const caseResultTemplate = require<string>("../../search/views/case-result.html");
const statuteResultTemplate = require<string>("../../search/views/statute-result.html");
const statuteSectionResultTemplate = require<string>("../../search/views/statute-section-result.html");
const siResultTemplate = require<string>("../../search/views/si-result.html");
const euResultTemplate = require<string>("../../search/views/eu-result.html");
const correctionTemplate = require<string>("../../search/views/correction-result.html");
const expandJurisdictionsTemplate = require<string>("../../search/views/expand-jurisdictions-result.html");

const dom = {
    SUMMARY: ".result-summary",
    SUMMARY_SHOW_MORE: "",
    PROCESSING_STATUS_CONTAINER: ".document-processing-status",
    POSITIVE_TREATMENT_BAR: ".mti-positive",
    NEUTRAL_TREATMENT_BAR: ".mti-neutral",
    NEGATIVE_TREATMENT_BAR: ".mti-negative",
    TITLE: ".result-title",
    COURT: ".result-court",
    REFERENCE: ".result-reference",
    DOCUMENT_CITATION_LINK: ".document-citation-link"
};

@backboneViewProperties({
    tagName: "li"
})
export class ResultView extends Marionette.ItemView<ResultModel> {
    public appEvents: Backbone.Events;
    public template: string;

    constructor(options?: Backbone.ViewOptions<ResultModel>) {
        super(options);
        this.setTemplate(options);
        this.setupEventListeners();
        this.appEvents = ContainerHelper.Events;
    }

    public render(): Marionette.ItemView<ResultModel> {
        this.$el.hide();
        super.render.call(this);
        this.$el.fadeIn(100);
        this.setupDocumentProcessingStatusPopover();
        this.setupCitationPopover();
        this.setupMobileTreatmentIndicators();
        return this;
    }

    public onShow() {
        this.updateSelectedForDownloadCheckbox();
    }

    public updateSelectedForDownloadCheckbox() {
        this.$(".download-select").prop("checked", this.model.SelectedForDownload);
    }

    public events(): Backbone.EventsHash {
        const ev: Backbone.EventsHash = {
            "click .summary-show-more": (e) => this.summaryShowMoreLinkClicked(e),
            "click .processing-link": (e) => this.processingLinkClick(e),
            "click .download-select": (e) => this.downloadSelectClicked(e),
            "click .statute-outline-link": (e) => this.onclickViewActOutline(e),
            "mouseover .report-available": (e) => this.highlightAppliedCitations(e),
            "mouseout .report-available": (e) => this.unhighlightAppliedCitations(e)
        };
        return ev;
    }

    public onclickViewActOutline(e) {
        e.preventDefault();
        const t = $(e.currentTarget);
        this.appEvents.trigger(AppEvents.ViewStatuteOutline, t.prop("pathname"));
    }
    public downloadSelectClicked(e) {
        const $checkbox = $(e.currentTarget);
        const checked = $checkbox.prop("checked");
        this.model.SelectedForDownload = checked;
    }

    private processingLinkClick(e) {
        e.preventDefault();
        this.$(dom.PROCESSING_STATUS_CONTAINER).popover("hide");
        const url = $(e.currentTarget).attr("href");
        Backbone.history.navigate(url, { trigger: true });
    }

    private setupEventListeners() {
        this.listenTo(this.model, "change:TruncatedSummary", this.truncatedSummaryChanged);
        this.listenTo(this.model, "change:HasFullText", this.fullTextChanged);
        this.listenTo(this.model, "change:SelectedForDownload", this.updateSelectedForDownloadCheckbox);
        $(window).resize(() => {
            this.$(dom.TITLE).width(`${this.model.getPartOneWidth()}%`);
            this.$(dom.COURT).width(`${this.model.getPartTwoWidth()}%`);
            this.$(dom.REFERENCE).width(`${this.model.getPartTwoWidth()}%`);
        });
    }

    private fullTextChanged(model, prop) {
        this.$el.toggleClass("full-text", prop);
    }

    private summaryShowMoreLinkClicked(e: JQueryMouseEventObject): void {
      //  this.model.TruncatedSummary = false;
    }

    /** Occurs when the model's TruncatedSummary is changed */
    private truncatedSummaryChanged(): void {
        this.$(dom.SUMMARY).text(this.model.Summary);
    }

    private setTemplate(options) {
        switch (options.model.get("DocTypeString")) {
            case "CASE":
                this.template = caseResultTemplate;
                break;
            case "CORRECTION":
                this.template = correctionTemplate;
                break;
            case "EXPAND_JURISDICTIONS":
                this.template = expandJurisdictionsTemplate;
                break;
            case "STATUTE":
                this.template = statuteResultTemplate;
                break;
            case "STATUTE_SECTION":
                this.template = statuteSectionResultTemplate;
                break;
            case "SI":
                this.template = siResultTemplate;
                break;
            case "EU_SECTOR0":
            case "EU_SECTOR1":
            case "EU_SECTOR2":
            case "EU_SECTOR3":
            case "EU_SECTOR4":
            case "EU_SECTOR5":
            case "EU_SECTOR6":
            case "EU_SECTOR7":
            case "EU_SECTOR8":
            case "EU_SECTOR9":
            case "EU_SECTORC":
                this.template = euResultTemplate;
                break;
            default:
                this.template = caseResultTemplate;
        }
    }

    private setupDocumentProcessingStatusPopover() {
            const $objProcessing = this.$(dom.PROCESSING_STATUS_CONTAINER);
            let hdr = "Processing status: ";
            if (this.model.get("FailedProcessing")) {
                hdr += "Failed";
                $objProcessing.removeClass("processing-completed").addClass("processing-failed");
            } else {
                hdr += "Completed";
                $objProcessing.removeClass("processing-failed").addClass("processing-completed");
            }

            const html = (this.model.get("LastBatchId") === "00000000-0000-0000-0000-000000000000") ?
                    "Batch information not available" :
                    `See the latest <a class='processing-link' href='processing/batch/${this.model.get("LastBatchId")}/${this.model.get("EntityId")}'>process log</a>`;

            $objProcessing.attr("data-content", html);
            $objProcessing.attr("data-title", hdr);
            $objProcessing.popover({
                placement: "left",
                html: true,
                trigger: "manual"
            })
            .hover((e) => { this.$(dom.PROCESSING_STATUS_CONTAINER).attr("title", hdr); })
            .click((e) => {
                $(dom.PROCESSING_STATUS_CONTAINER).not(this.$(dom.PROCESSING_STATUS_CONTAINER)).popover("hide");
                this.$(dom.PROCESSING_STATUS_CONTAINER).popover("show");
                return false;
            });
    }

    private setupCitationPopover() {
        const $court = this.$(".result-court");
        const hdr = "Citations";
        const html = this.$(".citation-information").html();
        $court.attr("data-content", html);
        $court.attr("data-title", hdr);
        $court.popover({
            placement: (context, source) => {
                const pos = $(source).offset();
                if ((pos.left - 600) > 50) { // want at least 50px from edge of screen, otherwise put it right
                    return "left";
                } else {
                    return "right";
                }
            },
            html: true,
            trigger: "manual",
            viewport: "#search-region",
            container : "#search-region",
            template: '<div class="popover" role="tooltip" style="width: 500px; max-width:500px;"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"><div class="data-content"></div></div></div>'
        })
        .click(() => {
            this.appEvents.trigger(AppEvents.SettingsClose);
            $(".result-court").not($court).popover("hide");
            $court.popover("toggle");
            return false;
        });
    }

    private setupMobileTreatmentIndicators() {
        if (this.model.PositiveTreatments === 0) {
            this.$(dom.POSITIVE_TREATMENT_BAR).hide();
        }
        if (this.model.NeutralTreatments === 0) {
            this.$(dom.NEUTRAL_TREATMENT_BAR).hide();
        }
        if (this.model.NegativeTreatments === 0) {
            this.$(dom.NEGATIVE_TREATMENT_BAR).hide();
        }
        this.$(dom.POSITIVE_TREATMENT_BAR).text(this.model.PositiveTreatments + " Positive");
        this.$(dom.NEUTRAL_TREATMENT_BAR).text(this.model.NeutralTreatments + " Neutral");
        this.$(dom.NEGATIVE_TREATMENT_BAR).text(this.model.NegativeTreatments + " Negative");
    }

    private highlightAppliedCitations(e: JQueryEventObject) {
        const hoveredSource = $(e.currentTarget).attr("alt");
        const linksToHighlight = this.$(dom.DOCUMENT_CITATION_LINK).filter((idx, elem) => elem.getAttribute("title") === hoveredSource);

        if (linksToHighlight) {
            linksToHighlight.removeClass("no-citation-match").addClass("citation-match");
        }
    }

    private unhighlightAppliedCitations(e: JQueryEventObject) {
        const hoveredSource = $(e.currentTarget).attr("alt");
        const linksToUnhighlight = this.$(dom.DOCUMENT_CITATION_LINK).filter((idx, elem) => elem.getAttribute("title") === hoveredSource);

        if (linksToUnhighlight) {
            linksToUnhighlight.each((idx, elem) => {
                const reportCitation = this.model.ReportCitations.find((c) => c.Source.Name === elem.getAttribute("title"));
                if (!reportCitation.Display) {
                    $(elem).removeClass("citation-match").addClass("no-citation-match");
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/result.ts